
/* Remove no-longer-supported localStorage info */
const self = sessionStorage.getItem('identity');
if (self)
{
  const selfStorageJSON = localStorage.getItem(self);
  if (selfStorageJSON)
  {
    const selfStorage = JSON.parse(selfStorageJSON);
    if (selfStorage.workerPaymentAccount)
    {
      const workerPaymentAccountSafe = {
        dbKey:   selfStorage.workerPaymentAccount.dbKey,
        address: selfStorage.workerPaymentAccount.address,
        label:   selfStorage.workerPaymentAccount.label,
      };
      selfStorage.workerPaymentAccount = workerPaymentAccountSafe;
    }
    localStorage.setItem(self, JSON.stringify(selfStorage));
  }
  sessionStorage.removeItem('identity');
}
    